import React from 'react';
import {Col, Row} from 'react-bootstrap';

export default function MeasurementText(props) {
    let unit = 'L';
    let isCurrencyUnit = false;
    switch (props?.unit?.toLowerCase()) {
        case 'gallons':
            unit = 'G';
            break;
        case 'ccf':
            unit = 'CF';
            break;
        case 'cubic_m':
        case 'cubic_meters':
            unit = 'CM';
            break;
        case 'nis':
        case 'ils':
            isCurrencyUnit = true
            unit = '₪';
            break;
        case 'usd':
            isCurrencyUnit = true
            unit = '$';
            break;
        case 'eur':
        case 'euro':
            isCurrencyUnit = true
            unit = '€';
            break;
        case 'gbp':
            isCurrencyUnit = true
            unit = '£';
            break;
        case 'tons':
            unit = 'Tons';
            break;
        case 'liters':
        default:
            unit = 'L';
            break;
    }

    function intToString(value) {
        let suffixes = ['', 'K', 'M', 'B', 'T'];
        let suffixNum = Math.floor(('' + value).length / 3);
        let shortValue = parseFloat((suffixNum !== 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));
        if (shortValue % 1 !== 0) {
            shortValue = shortValue.toFixed(1);
        }
        return shortValue + suffixes[suffixNum];
    }

    return (<Row>
            <Col md={6} className={'measurement-text'}>
                {!isCurrencyUnit ? <>
                    {props.value.toString().length > 7 ? <p>{intToString(props.value)}</p> :
                        <p>{props.value.toLocaleString()}</p>}
                    <p className={unit === 'Tons' ? 'ml-1 measurement-unit' : 'measurement-unit'}>{unit}</p>
                </> : props.value.toString().length > 7 ? <p>{unit + intToString(props.value)}</p> :
                    <p>{unit + props.value.toLocaleString()}</p>}
            </Col>
        </Row>
    )
}